import React from 'react';
import s from '../About/About_us.module.css';
// import logo from '../../images/header/logo.png';
import Container from '../Container/Container';

export default function about_us() {
  return (
    <div className={s.Main_banner}>
      <Container>
        <p className={s.about_us}>ПРО НАС</p>
      </Container>
    </div>
  );
}
